
import router from "@/router";
import { defineComponent, reactive, ref, Ref } from "vue";
import { Field, Form, ErrorMessage } from "vee-validate";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import $API from "@/services";
import {
  IAlert,
  RouterName,
} from "@/models/common";
import { messageType } from "@/models/message";
import { useStore } from "@/store";
import { CommonMutationTypes } from "@/store/modules/common/mutations";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "Reset Passwored",
  setup() {
    const data = reactive({
      email: "",
      password: "",
      passwordConfirm: "",
    });

    const {t} = useI18n();

    const state = reactive({
      code: router.currentRoute.value.query?.code,
    });

    const alert: Ref<IAlert> = ref({
      type: messageType.ERROR,
      content: "",
    });

    const store = useStore();

    return { state, data, alert, store, t };
  },
  methods: {
    clearMessage() {
      this.$router.push("/");
    },
    async resetPassword() {
      try {
        this.store.commit(CommonMutationTypes.SET_IS_LODING, true);
        const code = this.state.code as string;
        if (!code) {
          this.alert = {
            content: "Error",
            type: messageType.ERROR,
          };
          return;
        }
        this.store.commit(CommonMutationTypes.SET_IS_LODING, false);

        const success = await $API.SignService.resetPassword(
            this.data.email,
            this.data.password,
            code
          );

        if (success) {
          this.alert = {
            title: this.data.email,
            content: this.t('password changed') ,
            type: messageType.INFO,
            callback: () => {
              router.push(RouterName.SIGNIN);
            },
          };
        } 
      } catch (e:any) {
        console.error(e);

         if (e.ResultData === "Token is invalid") {
          this.alert = {
            title: this.t('change password'),
            content: this.t('password was changed or expired'),
            type: messageType.ERROR,
          };
        }
        this.store.commit(CommonMutationTypes.SET_IS_LODING, false);
      }
    },
  },
  components: {
    Field,
    Form,
    InputText,
    Button,
    ErrorMessage
  },
});
